/*
 * Build detail tabs: pure model, no React. The counts shown next to the tab names.
 */
import type { BuildCheck } from '@/api/schemas';

/** "3/5": the checks that passed out of all of them. */
export const checksTally = (checks: Pick<BuildCheck, 'status'>[]): string => `${checks.filter((c) => c.status === 'passed').length}/${checks.length}`;

/** The count next to the Checks tab: the tally once checks exist, nothing before ("0/0" says nothing). */
export const checksBadge = (checks: Pick<BuildCheck, 'status'>[]): string | null => (checks.length > 0 ? checksTally(checks) : null);
